import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neoris-catalogue-management',
  templateUrl: './catalogue-management.component.html',
  styleUrls: ['./catalogue-management.component.css']
})
export class CatalogueManagementComponent implements OnInit {

  constructor() { 
    console.log('COnstructor catalogue')
  }

  ngOnInit(): void {
    const catalog =0
  }

}
